// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__ZgmmO","content":"styles_content__2v8I5","selectAll":"styles_selectAll__fDL8y"};